import { gsap, ScrollTrigger, SplitText } from '../global/gsap';

const initLoadIn = (elements) => {
    // set options
    const durationTime = 0.85;
    const easing = 'power4';
    const startPos = 'top 95%';

    const fadeEls = [];
    const wordEls = [];

    elements.forEach((element) => {
        if (element.classList.contains('js-word-animate')) {
            const split = new SplitText(element, { type: 'words', mask: 'words' });
            wordEls.push([element, split]);
        } else if (element.classList.contains('rich-text')) {
            const subEls = element.querySelectorAll(':scope > *');

            gsap.set(subEls, {
                opacity: 0
            });

            gsap.set(element, {
                opacity: 1
            });

            if (subEls) {
                subEls.forEach((subEl) => {
                    fadeEls.push(subEl);
                });
            }
        } else {
            fadeEls.push(element);
        }
    });

    // Set inital state to avoid flash of content
    gsap.set(fadeEls, {
        opacity: 0
    });

    ScrollTrigger.batch(fadeEls, {
        invalidateOnRefresh: true,
        start: startPos,
        onEnter: (batch) => gsap.to(
            batch, {
                duration: durationTime,
                opacity: 1,
                stagger: 0.05,
                ease: easing
            }
        )
    });

    if (wordEls && wordEls.length > 0) {
        wordEls.forEach((array) => {
            const element = array[0];
            const { words } = array[1];

            gsap.set(element, {
                opacity: 0
            });

            gsap.set(words, {
                opacity: 0,
                y: '105%'
            });

            gsap.set(element, {
                opacity: 1
            });

            const animation = gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom'
                }
            });

            animation.to(words, {
                opacity: 1,
                y: '0%',
                duration: words.length * 0.125,
                ease: 'power4.out',
                stagger: 0.05
            });
        });
    }
};

export { initLoadIn as default };
